import React from 'react';
//Components
import moment from 'moment';
import AnaLysisAccountsOptions from './analysisAccountOptions.jsx';
import AnaLysisAccountsSummary from './analysisAccountSummary.jsx';
import Loader from '../../../../components/loader.jsx';
import {FormattedMessage} from 'react-intl';

import ReportApi from '../../../../../api/report.jsx';

const tableMaxRows = 20;

class AnalysisAccounts extends React.Component {
  state = {
    count: 0,
    data: [],
    filters: [],
    loaded: true,
    page: 1,
    tableData: [],
    total: 0,
    showNoDataMessage: false,
  };

  componentWillMount() {
    let date = new Date();
    let filters = {
      dateFrom: moment(new Date(date.setMonth(date.getMonth() - 1))),
      dateTo: moment(new Date()),
      store: 0,
      systemType: 0,
    };

    this.setState({
      filters: filters,
    });
  }

  onPageChange = (page, event) => {
    const {count, fullReport} = this.state;
    const pagReport = fullReport.slice((page - 1) * count, count * page);

    this.setState({
      tableData: pagReport,
      page: page,
    });
  };

  updateReportData = (dateFrom, dateTo, branch, systemType) => {
    let filters = {
      dateFrom: dateFrom,
      dateTo: dateTo,
      branch: branch,
      systemType: systemType,
    };

    this.setState({
      data: [],
      loaded: false,
    });
    ReportApi.getWaterAnalysisAccounts(dateFrom, dateTo, branch, systemType)
            .then(res => {
              if(res && res.TotalAccounts > 0) {
                this.setState({
                  count: tableMaxRows,
                  data: res,
                  filters: filters,
                  fullReport: res.AnalysisAccounts,
                  page: 1,
                  showNoDataMessage: false,
                  tableData: res.AnalysisAccounts.slice(0, tableMaxRows),
                  total: res.AnalysisAccounts.length,
                });
              } else {
                this.setState({showNoDataMessage: true});
              }
              this.setState({loaded: true});
            }).catch((e) => {
              console.log(e);
              this.setState({loaded: true,showNoDataMessage: true});
            });
  };

  render() {
    return (
      <div className="report-container">
        <span>
          <FormattedMessage id="reports.analysis.accounts.description" />
        </span>
        <AnaLysisAccountsOptions updateReportData={this.updateReportData} branches={this.props.branches} defaultFilters={this.state.filters} />
        <Loader loaded={this.state.loaded}>
          <AnaLysisAccountsSummary
						POSActive={this.props.POSActive}
						count={this.state.count}
						data={this.state.data}
						filters={this.state.filters}
						onPageChange={this.onPageChange}
						page={this.state.page}
						showNoDataMessage={this.state.showNoDataMessage}
						tableData={this.state.tableData}
						total={this.state.total}
					/>
        </Loader>
      </div>
    );
  }
}

export default AnalysisAccounts;
